<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-card class="mb-2">
            <div class="d-flex align-items-center">
                <div @click="$router.push('/sms-send')" class="border-right pr-1 pointer">
                    <div class="text-center mb-50">
                        <feather-icon icon="ArrowRightIcon" size="26" />
                    </div>
                    <div style="font-size: 13px;">بازگشت</div>
                </div>
                <div class="px-1">
                    <h5 class="font-weight-bolder mb-50">درخواست ارسال پیامک</h5>
                    <h5 class="mb-0">ارسال گروهی</h5>
                </div>
            </div>
        </b-card>

        <b-row>
            <b-col xl="6" lg="5" md="12" class="order-2 order-lg-1">
                <b-card>
                    <b-alert variant="warning" show>
                        <p class="alert-body text-center">
                            زمان ارسال باید حداقل ۱۲ ساعت بعد از حال حاضر باشد. پس از ثبت، درخواست شما توسط تیم پشتیبانی
                            بررسی شده و در صورت نداشتن مشکل، پیامک در زمان تعیین‌شده برای مشتریان انتخاب‌شده ارسال خواهد
                            شد.
                        </p>
                    </b-alert>
                    <validation-observer ref="requestSendSMS">
                        <b-form @submit.prevent class="px-1 pt-50">
                            <b-row>
                                <b-col xl="6" lg="12">
                                    <b-form-group label="عنوان درخواست" class="text-center">
                                        <validation-provider #default="{ errors }" name="عنوان درخواست"
                                            rules="required">
                                            <b-form-input dir="ltr" v-model="form.title"
                                                :class="errors.length > 0 ? 'border-danger' : null" autocomplete="off"
                                                class="text-center"></b-form-input>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="6" lg="12">
                                    <b-form-group label="زمان ارسال" class="text-center">
                                        <validation-provider #default="{ errors }" name="زمان ارسال" rules="required">
                                            <b-form-input id="dateTimeId" @focus="updateMinSelectableDate"
                                                class="text-center main-input pointer"
                                                :class="errors.length > 0 ? 'border-danger' : null"
                                                :value="form.dateTime" autocomplete="off" name="dateTimeId" />
                                            <date-picker v-model="form.dateTime" :min="minSelectableDate"
                                                type="datetime" format="YYYY-MM-DDTHH:mm:ss.SSSZ"
                                                display-format="jYYYY/jMM/jDD - HH:mm" custom-input="#dateTimeId" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col md="12" class="my-1">
                                    <b-form-group label="متن پیامک" label-for="messageId" class="text-center">
                                        <validation-provider #default="{ errors }" name="متن پیامک" rules="required">
                                            <b-form-textarea rows="4" no-resize autocomplete="off" dir="rtl"
                                                :class="errors.length > 0 ? 'border-danger' : null" id="messageId"
                                                v-model="form.message" name="message"></b-form-textarea>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="6" lg="12">
                                    <b-form-group label="نوع انتخاب مشتریان" label-for="groupId" class="text-center">
                                        <v-select v-model="requestType" :searchable="false" dir="rtl"
                                            :options="requestTypeData" :reduce="(value) => value.id" label="name"
                                            id="groupId" class="bg-white" style="border-radius: 6px;"
                                            :clearable="false">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                                <b-col xl="6" lg="12" v-if="requestType == 1">
                                    <div @click="$bvModal.show('customer-choice')" class="pointer mb-50">
                                        <div class="text-center">انتخاب مشتریان</div>
                                        <div class="border rounded mt-25 p-50 text-center">
                                            {{ selectedCount }} مشتری
                                        </div>
                                    </div>
                                </b-col>
                                <b-col xl="6" lg="12" v-else>
                                    <b-form-group label="کمپین ها" label-for="groupId" class="text-center">
                                        <v-select v-model="campaignDetails" :searchable="false" dir="rtl"
                                            :options="campaignsList" label="title" id="groupId" class="bg-white"
                                            style="border-radius: 6px;" :clearable="false">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <div class="mt-1">
                                <b-button type="submit" variant="primary" @click="requestSendSMS"
                                    :disabled="loadingButton"
                                    class="w-100 mt-75 d-flex align-items-center justify-content-center">
                                    <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                    <span>ثبت درخواست</span>
                                </b-button>
                            </div>
                        </b-form>
                    </validation-observer>
                </b-card>
            </b-col>
            <b-col xl="6" lg="7" md="12" class="order-1 order-lg-2">
                <b-card no-body class="position-sticky" style="top: 100px;">
                    <b-table responsive :items="Keys" :fields="fields" class="mb-0">
                        <template #cell(value)="data">
                            <b-badge v-clipboard:copy="data.item.value" v-clipboard:success="onCopy"
                                variant="light-primary" class="pointer">
                                {{ data.item.value }}
                            </b-badge>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>

        <!------------------------------- modal customers find ------------------------------->
        <b-modal id="customer-choice" title="انتخاب مشتریان" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <b-row>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="نام - نام خانوادگی - شماره اشتراک" label-for="searchTermId">
                        <b-form-input @keyup.enter="getCustomers" v-model="parameters.searchTerm" id="searchTermId"
                            autocomplete="off" class="text-center" name="searchTermId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="شماره همراه" label-for="phoneNumberId">
                        <b-form-input dir="ltr" type="number" @keyup.enter="getCustomers"
                            v-model="parameters.phoneNumber" id="phoneNumberId" autocomplete="off" class="text-center"
                            name="phoneNumberId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="شماره سطح" label-for="levelNumberId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.levelNumber" id="levelNumberId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="levelNumberId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="از امتیاز" label-for="startScoreId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minScore" id="startScoreId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="startScoreId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="تا امتیاز" label-for="endScoreId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxScore" id="endScoreId"
                            @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="endScoreId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="از تعداد خرید" label-for="minTotalOrdersCountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersCount"
                            @keyup.enter="getCustomers" id="minTotalOrdersCountId" autocomplete="off"
                            class="text-center" name="minTotalOrdersCountId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="تا تعداد خرید" label-for="maxTotalOrdersCountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersCount"
                            @keyup.enter="getCustomers" id="maxTotalOrdersCountId" autocomplete="off"
                            class="text-center" name="maxTotalOrdersCountId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="از آخرین خرید (روز)" label-for="minDaysNumberSinceLastOrderedId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minDaysNumberSinceLastOrdered"
                            @keyup.enter="getCustomers" id="minDaysNumberSinceLastOrderedId" autocomplete="off"
                            class="text-center" name="minDaysNumberSinceLastOrderedId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="تا آخرین خرید (روز)" label-for="maxDaysNumberSinceLastOrderedId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxDaysNumberSinceLastOrdered"
                            @keyup.enter="getCustomers" id="maxDaysNumberSinceLastOrderedId" autocomplete="off"
                            class="text-center" name="maxDaysNumberSinceLastOrderedId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="از مبلغ خرید" label-for="minTotalOrdersAmountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersAmount"
                            @keyup.enter="getCustomers" id="minTotalOrdersAmountId" autocomplete="off"
                            class="text-center" name="minTotalOrdersAmountId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="تا مبلغ خرید" label-for="maxTotalOrdersAmountId">
                        <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersAmount"
                            @keyup.enter="getCustomers" id="maxTotalOrdersAmountId" autocomplete="off"
                            class="text-center" name="maxTotalOrdersAmountId" />
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="وفاداری" label-for="groupId">
                        <v-select v-model="parameters.groupId" :searchable="false" dir="rtl" :options="groupIdData"
                            :reduce="(value) => value.id" label="name" id="groupId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="محصول مورد علاقه" label-for="favoriteProductId">
                        <v-select v-model="parameters.favoriteProductId" dir="rtl" :options="products"
                            :reduce="(value) => value.id" label="name_Fa" id="favoriteProductId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" class="mt-25">
                    <b-form-group label="نوع ترتیب نمایش" label-for="sortById">
                        <v-select v-model="parameters.sortBy" :searchable="false" dir="rtl" :options="sortByData"
                            :reduce="(value) => value.id" label="name" id="sortById" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="4" class="mt-25">
                    <b-form-group label="ترتیب نمایش" label-for="sortDescendingId">
                        <v-select v-model="parameters.sortDescending" :searchable="false" dir="rtl"
                            id="sortDescendingId" :options="sortDescendingData" :reduce="(value) => value.id"
                            label="name" class="bg-white" style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6" md="4" class="mt-50 mt-md-2 mt-lg-25">
                    <b-button @click="removeFilters" variant="secondary"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loading">
                        <span>حذف فیلتر ها</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col lg="6" md="4" class="mt-2 mt-md-2 mt-lg-25">
                    <b-button variant="info" @click="getCustomers" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col md="12" class="mt-2 mt-md-50 mt-lg-2">
                    <div class="d-flex align-items-center justify-content-between border border-info rounded px-1"
                        style="height: 41px;">
                        <div class="d-flex align-items-center">
                            <feather-icon size="18" icon="UsersIcon" class="mr-50" />
                            <h5 class="mb-0">مشتریان انتخاب شده</h5>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center mb-0 mr-50">
                                <h3 v-if="!loading" class="font-weight-bolder mb-0">{{ selectedCount }}</h3>
                                <b-spinner v-else small></b-spinner>
                            </div>
                            <span>مشتری</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-card class="p-0 mt-2" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table v-if="customerList.length" responsive :items="customerList" :fields="fieldsCustomer"
                        class="mb-0" striped>
                        <template #head(select)>
                            <b-form-checkbox :indeterminate="isIndeterminate" v-model="isAllSelected"
                                @change="toggleSelectAll"></b-form-checkbox>
                        </template>
                        <template #cell(select)="data">
                            <b-form-checkbox :checked="isRowChecked(data.item.id)"
                                @change="toggleRow(data.item.id, $event)"></b-form-checkbox>
                        </template>
                        <template #cell(lastName)="data">
                            {{ data.item.lastName ? data.item.lastName : '-' }}
                        </template>
                        <template #cell(firstName)="data">
                            {{ data.item.firstName ? data.item.firstName : '-' }}
                        </template>
                    </b-table>
                    <div v-else class="text-center pt-5 pb-4">
                        موردی وجود ندارد
                    </div>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getCustomers" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            <b-button variant="info" @click="$bvModal.hide('customer-choice')" class="w-100 mt-2 mb-50">
                تایید
            </b-button>

        </b-modal>
    </div>
</template>

<script>
import { BCard, BCardText, BMedia, BRow, BCol, BButton, BFormInput, BFormRadio, BFormCheckbox, BBadge, BAvatar, BAlert, BMediaAside, BMediaBody, BForm, BFormTextarea, BSpinner, BPagination, BOverlay, BTable, BFormGroup } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import { storeService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BMedia,
        BRow,
        BCol,
        BButton,
        BFormInput,
        BFormRadio,
        BBadge,
        BAvatar,
        BMediaAside,
        BMediaBody,
        BForm,
        BFormTextarea,
        BSpinner,
        BPagination,
        BOverlay,
        BTable,
        BFormCheckbox,
        BFormGroup,
        BAlert
    },
    data() {
        return {
            required,
            storeId: null,
            loading: true,
            loadingPage: true,
            loading: false,
            loadingButton: false,
            customerList: [],
            onlyCustomerIds: [],
            excludeCustomerIds: [],
            selectAll: false,
            isAllSelected: false,
            isIndeterminate: false,
            products: [],
            requestTypeData: [
                { name: 'دستی', id: 1 },
                { name: 'کمپین', id: 2 }
            ],
            requestType: 1,
            sortByData: [
                { name: 'تاریخ ایجاد', id: 0 },
                { name: 'امتیاز', id: 1 },
                { name: 'اعتبار', id: 2 },
                { name: 'زمان آخرین خرید', id: 3 },
                { name: 'تعداد خرید', id: 4 },
                { name: 'مبلغ خرید', id: 5 },
            ],
            groupIdData: [
                { name: 'همراهِ همیشگی', id: 1 },
                { name: 'همراهِ هفتگی', id: 2 },
                { name: 'همراهِ ماهانه', id: 3 },
                { name: 'لبه‌ی فراموشی', id: 4 },
                { name: 'مشتریان خاموش', id: 5 },
            ],
            sortDescendingData: [
                { name: 'صعودی', id: false },
                { name: 'نزولی', id: true }
            ],
            fieldsCustomer: [
                {
                    key: 'select',
                    label: '',
                },
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'number',
                    label: 'شماره اشتراک',
                },
            ],
            Keys: [
                { name: 'نام مشتری', value: '{{Customer.FirstName}}' },
                { name: 'نام خانوادگی مشتری', value: '{{Customer.LastName}}' },
                { name: 'شماره اشتراک مشتری', value: '{{Customer.Number}}' },
                { name: 'جمع امتیاز مشتری', value: '{{Customer.Score}}' },
                { name: 'جمع اعتبار مشتری', value: '{{Customer.WalletBalance}}' },
                { name: 'نام سطح فعلی مشتری', value: '{{Customer.LevelName}}' },
                { name: 'لینک ثبت نظر', value: '{{Store.CustomerCommentsUrl}}' },
                { name: 'لینک دیجیتالی باشگاه', value: '{{Store.ClubUrl}}' },
                { name: 'لینک مینی وب‌سایت مجموعه', value: '{{Store.ProfileUrl}}' },
                { name: 'نام مجموعه', value: '{{Store.Name}}' },
            ],
            fields: [
                {
                    key: 'value',
                    label: 'کلید',
                },
                {
                    key: 'name',
                    label: 'توضیحات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                searchTerm: null,
                sortBy: null,
                levelNumber: null,
                sortDescending: null,
                maxScore: null,
                minScore: null,
                groupId: null,
                maxTotalOrdersCount: null,
                minTotalOrdersCount: null,
                maxTotalOrdersAmount: null,
                minTotalOrdersAmount: null,
                maxDaysNumberSinceLastOrdered: null,
                minDaysNumberSinceLastOrdered: null,
                favoriteProductId: null,
            },
            form: {
                title: null,
                message: null,
                dateTime: null,
                customersFilters: null,
                excludeCustomerIds: [],
                onlyCustomerIds: [],
                campaignId: null
            },
            minSelectableDate: null,
            campaignsList: [],
            campaignDetails: null,
        };
    },
    watch: {
        requestType(value) {
            this.form.customersFilters = null
            this.form.excludeCustomerIds = []
            this.form.onlyCustomerIds = []
            this.form.campaignId = null
            this.campaignDetails = null
            this.parameters.totalCount = null
            this.onlyCustomerIds = []
            this.excludeCustomerIds = []
            this.selectAll = false
            this.isAllSelected = false
            this.isIndeterminate = false
            if (value == 1) {
                this.removeFilters()
            }
        },
    },
    computed: {
        selectedCount() {
            if (this.selectAll) {
                return this.parameters.totalCount - this.excludeCustomerIds.length;
            } else {
                return this.onlyCustomerIds.length;
            }
        }
    },
    methods: {
        requestSendSMS() {
            this.$refs.requestSendSMS.validate().then((success) => {
                if (success) {
                    if (this.selectedCount || this.requestType == 2) {
                        this.loadingButton = true
                        if (this.selectAll) {
                            this.form.customersFilters = {}
                            this.parameters.phoneNumber ? this.form.customersFilters.phoneNumber = this.parameters.phoneNumber : null
                            this.parameters.searchTerm ? this.form.customersFilters.searchTerm = this.parameters.searchTerm : null
                            this.parameters.favoriteProductId ? this.form.customersFilters.favoriteProductId = this.parameters.favoriteProductId : null
                            this.parameters.levelNumber ? this.form.customersFilters.levelNumber = this.parameters.levelNumber : null
                            this.parameters.groupId ? this.form.customersFilters.groupId = this.parameters.groupId : null
                            if (this.parameters.maxScore || this.parameters.minScore || this.parameters.minScore == 0) {
                                this.form.customersFilters.scoreRange = {}
                                this.parameters.minScore ? this.form.customersFilters.scoreRange.from = this.parameters.minScore : null
                                this.parameters.maxScore ? this.form.customersFilters.scoreRange.to = this.parameters.maxScore : null
                            }
                            if (this.parameters.maxDaysNumberSinceLastOrdered || this.parameters.minDaysNumberSinceLastOrdered || this.parameters.minDaysNumberSinceLastOrdered == 0) {
                                this.form.customersFilters.daysNumberSinceLastOrderedRange = {}
                                this.parameters.minDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.from = this.parameters.minDaysNumberSinceLastOrdered : null
                                this.parameters.maxDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.to = this.parameters.maxDaysNumberSinceLastOrdered : null
                            }
                            if (this.parameters.maxTotalOrdersCount || this.parameters.minTotalOrdersCount || this.parameters.minTotalOrdersCount == 0) {
                                this.form.customersFilters.totalOrdersCountRange = {}
                                this.parameters.minTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.from = this.parameters.minTotalOrdersCount : null
                                this.parameters.maxTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.to = this.parameters.maxTotalOrdersCount : null
                            }
                            if (this.parameters.maxTotalOrdersAmount || this.parameters.minTotalOrdersAmount || this.parameters.minTotalOrdersAmount == 0) {
                                this.form.customersFilters.totalOrdersAmountRange = {}
                                this.parameters.minTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.from = this.parameters.minTotalOrdersAmount : null
                                this.parameters.maxTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.to = this.parameters.maxTotalOrdersAmount : null
                            }
                            this.form.excludeCustomerIds = this.excludeCustomerIds
                            this.form.onlyCustomerIds = []
                        }
                        else {
                            this.form.customersFilters = null
                            this.form.onlyCustomerIds = this.onlyCustomerIds
                            this.form.excludeCustomerIds = []
                        }
                        if (this.campaignDetails) {
                            this.form.campaignId = this.campaignDetails.id
                        }
                        storeService.sendSMSSchedules(this.storeId, this.form).then(({ data }) => {
                            this.$refs.requestSendSMS.reset();
                            this.$notif({ type: 'success', title: 'درخواست با موفقیت ثبت شد' });
                            this.$bvModal.hide('customer-choice')
                            this.$router.push('/sms-send')
                        })
                            .finally(() => {
                                this.loadingButton = false
                            });
                    }
                    else {
                        this.$bvModal.show('customer-choice')
                    }
                }
            });
        },
        updateMinSelectableDate() {
            const now = new Date();
            const twelveHoursAhead = new Date(now.getTime() + 12 * 60 * 60 * 1000);
            const yyyy = twelveHoursAhead.getFullYear();
            const mm = String(twelveHoursAhead.getMonth() + 1).padStart(2, "0");
            const dd = String(twelveHoursAhead.getDate()).padStart(2, "0");
            const hh = String(twelveHoursAhead.getHours()).padStart(2, "0");
            const min = String(twelveHoursAhead.getMinutes()).padStart(2, "0");
            const ss = String(twelveHoursAhead.getSeconds()).padStart(2, "0");
            this.minSelectableDate = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        },
        onCopy() {
            this.$notif({ type: 'normal', title: 'کپی کلید با موفقیت انجام شد' });
        },
        isRowChecked(id) {
            if (this.selectAll) {
                return !this.excludeCustomerIds.includes(id);
            } else {
                return this.onlyCustomerIds.includes(id);
            }
        },
        toggleRow(id, checked) {
            if (this.selectAll) {
                if (!checked) {
                    if (!this.excludeCustomerIds.includes(id)) {
                        this.excludeCustomerIds.push(id);
                    }
                } else {
                    this.excludeCustomerIds = this.excludeCustomerIds.filter(x => x !== id);
                }
            } else {
                if (checked) {
                    if (!this.onlyCustomerIds.includes(id)) {
                        this.onlyCustomerIds.push(id);
                    }
                } else {
                    this.onlyCustomerIds = this.onlyCustomerIds.filter(x => x !== id);
                }
            }
            this.updateHeaderCheckbox();
        },
        toggleSelectAll(checked) {
            this.selectAll = checked;
            this.isIndeterminate = false;
            if (checked) {
                this.onlyCustomerIds = [];
                this.excludeCustomerIds = [];
            } else {
                this.onlyCustomerIds = [];
                this.excludeCustomerIds = [];
            }
        },
        updateHeaderCheckbox() {
            const pageIds = this.customerList.map(c => c.id);
            let selectedCount = 0;
            if (this.selectAll) {
                selectedCount = pageIds.filter(id => !this.excludeCustomerIds.includes(id)).length;
            } else {
                selectedCount = pageIds.filter(id => this.onlyCustomerIds.includes(id)).length;
            }
            if (selectedCount === pageIds.length) {
                this.isAllSelected = true;
                this.isIndeterminate = false;
            } else if (selectedCount > 0) {
                this.isAllSelected = false;
                this.isIndeterminate = true;
            } else {
                this.isAllSelected = false;
                this.isIndeterminate = false;
            }
        },
        removeFilters() {
            this.parameters.phoneNumber = null;
            this.parameters.searchTerm = null;
            this.parameters.sortBy = null;
            this.parameters.levelNumber = null;
            this.parameters.sortDescending = null;
            this.parameters.maxScore = null;
            this.parameters.minScore = null;
            this.parameters.groupId = null;
            this.parameters.maxTotalOrdersCount = null;
            this.parameters.minTotalOrdersCount = null;
            this.parameters.maxTotalOrdersAmount = null;
            this.parameters.minTotalOrdersAmount = null;
            this.parameters.maxDaysNumberSinceLastOrdered = null;
            this.parameters.minDaysNumberSinceLastOrdered = null;
            this.parameters.favoriteProductId = null;
            this.getCustomers()
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                let categories = data.categories
                if (categories.length) {
                    categories.forEach(obj => {
                        obj.products.forEach(product => {
                            this.products.push(product)
                        });
                    });
                }
                this.getCustomers()
            })
        },
        getCustomers() {
            this.loading = true
            storeService.getCustomers(this.storeId, this.parameters).then(({ data }) => {
                if (this.selectAll && this.parameters.totalCount !== null && this.parameters.totalCount !== data.totalCount) {
                    this.excludeCustomerIds = [];
                    this.onlyCustomerIds = [];
                    this.selectAll = false;
                    this.isAllSelected = false;
                    this.isIndeterminate = false;
                }
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.customerList = data.items
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.customerList = data.items
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getCampaignsActives() {
            storeService.getCampaignsActives(this.storeId).then(({ data }) => {
                let campaignsList = data.items
                campaignsList.forEach(item => {
                    if (item.type == 1) {
                        this.campaignsList.push(item)
                    }
                });
                this.getAllProducts()
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCampaignsActives()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
